import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import TravelList from '../../../components/List/Travel/TravelList'
import { TravelOverviewDto } from '../../../config/registrationConfig'
import { RegistrationListProps } from '../../../components/List/Registration/RegistrationList'
import useEntity from '../../../hooks/useEntity'
import { useTranslation } from 'react-i18next'
import { Spinner, SpinnerSize } from '@fluentui/react'

export default function TravelOverview(props: RegistrationListProps<TravelOverviewDto>): ReactElement {
    const { t: translate } = useTranslation()

    const [lazyItems, , resetLazyItems] = useEntity<TravelOverviewDto[]>(
        () => ({ url: `/file/${props.listProps.file.id}/travel` }),
        props.items === null ? false : null,
    )
    const isItemsLoaded = useMemo(() => props.items !== null || lazyItems.loaded, [props.items, lazyItems])

    const lazyProps: RegistrationListProps<TravelOverviewDto> = useMemo(
        () => ({ ...props, items: lazyItems?.data, reset: resetLazyItems }),
        [isItemsLoaded],
    )

    if (!isItemsLoaded) {
        return <Spinner label={translate('base.loading')} size={SpinnerSize.small} labelPosition="right" />
    }
    if (props.items === null) {
        return <TravelList {...lazyProps} />
    }

    return <TravelList {...props} />
}
